import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ToastService } from '../page-elements/toast/toast.service';
import { AccountService } from './account.service';
import { AuthorizationService } from './authorization.service';

const ACCOUNT_STORAGE_KEY = 'account';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  logoutCalled = new EventEmitter();
  private readonly storageListener = (event: StorageEvent): void => {
    if (event.key !== ACCOUNT_STORAGE_KEY || event.newValue !== null) {
      return;
    }

    this.logoutLocally();
    this.router.navigate(['/']);
  };

  constructor(
    private http: HttpClient,
    private router: Router,
    private accountService: AccountService,
    private authorizationService: AuthorizationService,
    private toastService: ToastService,
  ) {
    window.addEventListener('storage', this.storageListener);
  }

  login(): Observable<string[]> {
    return this.http.get<string[]>(environment.apiUrl + 'account/perms').pipe(tap(perms => {
      localStorage.setItem(ACCOUNT_STORAGE_KEY, btoa(JSON.stringify(perms)));
    }));
  }

  logout(sessnEndMthdCd: string) {
    this.logoutLocally();

    this.http.get<any>(environment.apiUrl + 'authenticate/logout', {
      params: {
        sessnEndMthdCd: sessnEndMthdCd
      }
    }).subscribe(() => {
    });
  }

  logoutLocally(): void {
    localStorage.removeItem(ACCOUNT_STORAGE_KEY);
    this.authorizationService.clearSubjPerms();
    this.logoutCalled.emit();
    this.accountService.clearAccount();
    this.toastService.removeAll();
  }

  isLoggedIn() {
    return localStorage.getItem(ACCOUNT_STORAGE_KEY) !== null;
  }

}
